<template>
    <transition name="common-enter-animation" mode="out-in" appear>
        <div class="visible-filters-wrapper" :class="{ mobile: getMobileAppState }">
            <div class="visible-filters" :class="{ 'filters-applied': !!filterTags.length }">
                <div class="left-content">
                    <slot></slot>
                    <!-- Apply Filters Button -->
                    <button-secondary
                    :label="!getMobileAppState ? t('filters.applyFilters') : null"
                    icon="check-line"
                    buttonSize="small"
                    :disabled="applyButtonDisabled"
                    @clicked="emit('applyFilters')" />
                </div>

                <slot name="extra-elements-to-right"></slot>
            </div>
            <!-- Filter Tags -->
            <button-chip
            v-if="!!filterTags.length"
            :filters="filterTags"
            @close="emit('removeFilterTag', $event)"
            @closeAll="emit('closeAllFilters')" />
        </div>
    </transition>
</template>

<script setup>
import ButtonSecondary from '@/components/generic/buttons/Secondary'
import ButtonChip from '@/components/generic/buttons/chip/ChipWrapper'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['applyFilters', 'removeFilterTag', 'closeAllFilters'])

/** Props
@filterTags { Array }
@applyButtonDisabled { Boolean }
*/
const props = defineProps({
    filterTags: Array,
    applyButtonDisabled: Boolean
})

/* mapGetters */
const { getMobileAppState } = mapGetters()
</script>

<style lang="scss" scoped>
.visible-filters-wrapper {
    @include commonEnteringAnimation;
    width: 100%;

    .visible-filters {
        width: 100%;
        position: relative;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 8px;

        .left-content {
            width: 100%;
            display: flex;
            align-items: flex-end;

            gap: 8px;
        }
    }

    &.mobile {
        padding-bottom: 16px;

        .visible-filters {
            :deep(.input-elements-container),
            :deep(.dropdown-wrapper) {
                flex-grow: 1;
                flex-basis: 0;
            }
        }

        .chips-wrapper-container {
            &:after {
                content: '';

                position: absolute;
                bottom: 0;
                left: -48px;

                width: calc(100% + 32px);
                height: 1px;

                background-color: var(--secondary-light-2);
            }
        }
    }

    &:not(.mobile) {
        .visible-filters {
            padding-bottom: 16px;
            gap: 16px;

            .left-content {
                width: auto;
                flex-flow: row wrap;
            }

            &.filters-applied {
                &:after {
                    content: '';

                    position: absolute;
                    bottom: 0;
                    left: -16px;

                    width: calc(100% + 32px);
                    height: 1px;

                    background-color: var(--secondary-light-2);
                }
            }
        }
    }
}
</style>
